import React from 'react';
import * as mystyles from '../styles/Tooltip.module.scss';
export default function tooltip({title, children}){
    return (
        <div className=" relative">
             <span className={`${mystyles.text}`}>
                { children }
            </span>
            <div className={`${mystyles.tooltip} z-10 absolute -top-8 -translate-x-1/2 left-2/4 transform transition-all duration-300 whitespace-nowrap`}>
                <div className="bg-black text-white text-xs rounded py-1 px-4 right-0 bottom-full">
                {title}
                    <svg className="absolute text-black h-2 w-full left-0 top-full" x="0px" y="0px" viewBox="0 0 255 255" xmlSpace="preserve"><polygon className="fill-current" points="0,0 127.5,127.5 255,0"/></svg>
                </div>            
            </div>
        </div>
    )
}